import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Link,
  Stack,
  Typography
} from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PopupComponent } from 'src/components/common/PopupComponent';
import ProgressBar from 'src/components/common/ProgressBar';
import { usePermissionWrapper } from 'src/components/hooks/usePermissionWrapper';
import { useTab } from 'src/components/hooks/useTab';
import { useUser } from 'src/components/hooks/useUser';
import { useGetSysAdminNewCodelistQuery } from 'src/services/workarea';
import { AppState } from 'src/store';
import { setMessage } from 'src/store/Message';
import { setConfirmExitValue } from 'src/store/confirmExitValue';
import { setConfirmExitPopupVal } from 'src/store/confirmPopupVal';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { updateUserAccess } from 'src/util/util';
import { useFieldTranslation } from '../../fields/useFieldTranslation';
import { hideLoader, showLoader } from 'src/store/Loader';
import './IpManagement.scss';
import Ipreleasepage from './IpRelease';
import IpSupplyOrderpage from './IpSupplyOrder';
import { useIPManagement } from './useIPManagement';
import { useSelectedAppInfo } from 'src/util/SelectedAppInfo';
import IpMangementSubmitModal from './Submit';
import { archLevel } from 'src/data/config';
import AppModal from 'src/components/modal';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import { DataTable } from '@pihealth/common-ui-library';
import { GridToolbarExport } from '@mui/x-data-grid-pro';
import moment from 'moment';
import { setNewResupplyOrder, setOpenResupplyOrderPage, setSelectedResupply } from 'src/store/drugSupplySlice';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useUtil } from 'src/components/hooks/useUtil';

const IpManagementPage: React.FunctionComponent<any> = () => {
  const { setTabVal, tabVal, tabsData } = useTab();
  const currentTabinfo: any = tabsData.filter((item: any) => item.index === tabVal);
  const { checkPermission } = usePermissionWrapper();
  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const selectedSite = useAppSelector(state => state.site.selectedSite);
  const application = process.env.REACT_APP_NAME;
  const dispatch = useDispatch();
  const dispatchApp = useAppDispatch();
  const [expanded, setExpanded] = React.useState<string | false>('panel1');
  const { user } = useUser();

  const isLoading = false;
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isIPReleaseSaved, setIsIPReleaseSaved] = useState(false);
  const [isIPSupplySaved, setIsIPSupplySaved] = useState(false);
  const [openSubmitConfirmDialog, setOpenSubmitConfirmDialog] = React.useState(false);
  const [isSignsCompleted, setIsSignsCompleted] = React.useState(false);
  const ipCodeList = 'IPMGDST';
  const [isSignsCompletedLegacy, setIsSignsCompletedLegacy] = React.useState(false);

  const [checkboxVal, setCheckboxVal] = useState(false);
  const [isIpReleaseCertified, setIpReleaseCertified] = useState(false);
  const checkboxInputRef = React.useRef<any>();
  const [ipReleaseData, setIPReleaseData] = useState([]);
  const [updatedIPReleaseDocs, setUpdatedIPReleaseDocs] = useState([]);
  const { ipmDataUpdateSuccessMsg, ipmErrorMsg } = useFieldTranslation();
  const { selectedApp } = useSelectedAppInfo();
  const currentApp = selectedApp === process.env.REACT_APP_STUDYCONDUCT_SLUG ? 'CONDUCT' : 'STARTUP';
  const [openSubmitModal, setOpenSubmitModal] = useState<boolean>(false);
  const [openSponsorSubmitModal, setOpenSponsorSubmitModal] = useState<boolean>(false);
  const [siteSubmitSuccess, setSiteSubmitSuccess] = useState<boolean>(false);
  const { getPreferredDateTimeInLocal } = usePreferedDateFormat();
  const [isIPSupplyChanged, setIsSupplyChanged] = useState(false);
  const { unSavedWarning } = useFieldTranslation();
  const [openConfirmExit, setOpenConfirmExit] = useState(false);
  const [ipSupplyData, setIpSupplyData] = useState<any>({});

  const handleChange = (panel: string) => (_: React.SyntheticEvent, isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : false);
  };

  const { data: iprtsData } = useGetSysAdminNewCodelistQuery(ipCodeList);
  const accRef: any = useRef<HTMLDivElement>(null);
  const { handleError } = useUtil();
  const {
    ipReleaseQueryData,
    getIpReleaseError,
    getIpReleaseQueryData,
    updateIpRelease,
    createIpRelease,
    getLazyIpReleaseQueryData,
    createIpReleaseIsSuccess,
    createIpReleaseIsError,
    createIpReleaseLoading,
    getIpReleaseLoading,
    updateIpReleaseLoading,
    getIpSupplyOrderQueryData,
    ipSupplyOrderQueryData,
    getIpSupplyOrderIsError,
    getIpSupplyOrderSucess,
    approveSubmitIPSuply,
    approveSubmitIsSuccess,
    getAllIpResupply,
    ipResupplyIsLoading,
    ipResupplyIsError,
    ipResupplyData,
    ipResupplyIsSuccess,
    ipResupplyError,
    getAllIpResupplySponsor,
    ipResupplySponsorIsLoading,
    ipResupplySponsorIsError,
    ipResupplySponsorData,
    ipResupplySponsorIsSuccess,
    ipResupplySponsorError
  } = useIPManagement();

  const confirmexitpopupval: any = useSelector((state: AppState) => state.confirmexitpopupval);
  const handleNextbtn = (_: any) => {
    const popupShowed = localStorage.getItem('popupShowed');
    if (popupShowed == 'true' && confirmexitpopupval.confirmexitpopupval == true) {
      setConfirmExitPopupVal(dispatch, false);
      setConfirmExitPopupVal(dispatch, true);
    }
    setTabVal(tabVal + 1);
  };

  useEffect(() => {
    if (siteSubmitSuccess) {
      getIpSupplyOrderQueryData();
      accRef?.current?.scrollTo(0, 0);
      window.scrollTo(0, 0);
    }
  }, [siteSubmitSuccess]);

  useEffect(() => {
    if (ipReleaseQueryData) {
      const result: any = ipReleaseQueryData;
      const newIpObj = result.map((obj: any) => {
        return { ...obj, error_msg: false };
      });

      const checkIsValidIPReleaseData = result.some((obj: any) => obj.ip_management_status === null);
      checkIsValidIPReleaseData ? setIsIPReleaseSaved(false) : setIsIPReleaseSaved(true);

      const checkCertifyInfo = result.every((obj: any) => obj.ip_management_certify_info === true);
      checkCertifyInfo ? setCheckboxVal(true) : setCheckboxVal(false);
      checkCertifyInfo ? setIpReleaseCertified(true) : setIpReleaseCertified(false);

      const isIPReleaseSubmitted = result.every((obj: any) => obj.is_submit === true);

      isIPReleaseSubmitted ? setIsSubmitted(true) : setIsSubmitted(false);

      setIPReleaseData(newIpObj);
      setUpdatedIPReleaseDocs([]);
    }
  }, [ipReleaseQueryData]);

  useEffect(() => {
    if (getIpReleaseError) {
      setIsIPReleaseSaved(false);
      updateUserAccess(getIpReleaseError, dispatch);
    }
  }, [getIpReleaseError]);

  useEffect(() => {
    if (ipSupplyOrderQueryData && getIpSupplyOrderSucess) {
      setIpSupplyData(ipSupplyOrderQueryData);
    }
  }, [ipSupplyOrderQueryData, getIpSupplyOrderSucess]);
  useEffect(() => {
    if (getIpSupplyOrderIsError) {
      setIpSupplyData({});
    }
  }, [getIpSupplyOrderIsError]);
  useEffect(() => {
    getIpReleaseQueryData();
    getIpSupplyOrderQueryData();
    return () => {
      dispatch(hideLoader());
    };
  }, [studyId, selectedCountry, selectedSite]);

  const createIPRelease = async (createReleaseObj: any) => {
    const reqObj = {
      ip_release: createReleaseObj,
      ip_management_certify_info: false,
      created_by: user
    };
    await createIpRelease({
      site_id: selectedSite,
      study_id: studyId,
      country: selectedCountry,
      application: process.env.REACT_APP_NAME,
      data: reqObj
    });
  };
  const updateIPRelease = async () => {
    if (updatedIPReleaseDocs.length > 0 || checkboxVal) {
      const ipReleseUpdateData = {
        ip_release_update: updatedIPReleaseDocs,
        ip_management_certify_info: checkboxVal,
        updated_by: user
      };
      const updateResponse: any = await updateIpRelease({
        site_id: selectedSite,
        study_id: studyId,
        country: selectedCountry,
        application: process.env.REACT_APP_NAME,
        data: ipReleseUpdateData
      });
      if (updateResponse.isSuccess) {
        setIsIPReleaseSaved(true);
        afterUpdateSuccess();
      } else if (updateResponse.isError) {
        setIsIPReleaseSaved(false);
      }
    }
  };

  const handleConfirmClose = () => {
    setOpenSubmitConfirmDialog(false);
  };

  const handleConfirmSubmit = async () => {
    handleConfirmClose();
    const ipManagementSubmit = {
      ip_management_certify_info: checkboxVal,
      is_submit: true,
      updated_by: user
    };
    const updateResponse: any = await updateIpRelease({
      site_id: selectedSite,
      study_id: studyId,
      country: selectedCountry,
      application: process.env.REACT_APP_NAME,
      data: ipManagementSubmit
    });
    if (updateResponse.isSuccess) {
      setIsSubmitted(true);
      afterUpdateSuccess();
    } else if (updateResponse.isError) {
      afterUpdateError();
    }
  };

  const handleSiteSubmit = () => {
    setOpenSubmitModal(true);
  };

  const handleSponsorSubmit = () => {
    setOpenSponsorSubmitModal(true);
  };

  const afterUpdateSuccess = () => {
    dispatchApp(setMessage({ msgDetails: ipmDataUpdateSuccessMsg, severity: 'success' }));
    setUpdatedIPReleaseDocs([]);
    getIpReleaseQueryData();
    setConfirmExitValue(dispatch, false);
  };
  const afterUpdateError = () => {
    dispatchApp(setMessage({ msgDetails: ipmErrorMsg, severity: 'error' }));
    setConfirmExitValue(dispatch, false);
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    if (currentApp !== 'CONDUCT') {
      if (getIpReleaseLoading || updateIpReleaseLoading || createIpReleaseLoading) {
        dispatch(showLoader());
      } else {
        dispatch(hideLoader());
      }
    }
  }, [getIpReleaseLoading, updateIpReleaseLoading, createIpReleaseLoading]);

  useEffect(() => {
    if (createIpReleaseIsError) {
      afterUpdateError();
    }
  }, [createIpReleaseIsError]);
  useEffect(() => {
    if (createIpReleaseIsSuccess) {
      getLazyIpReleaseQueryData({
        site_id: selectedSite,
        study_id: studyId,
        country: selectedCountry,
        application
      });
      setConfirmExitValue(dispatch, false);
    }
  }, [createIpReleaseIsSuccess]);

  const handleApproveSubmit = async () => {
    await approveSubmitIPSuply({
      site_id: selectedSite,
      study_id: studyId,
      country: selectedCountry,
      ip_supply_id: ipSupplyOrderQueryData?.id,
      application: 'TSDA',
      application_section: currentApp,
      data: { is_sponsor_approved: true }
    });
  };

  useEffect(() => {
    if (approveSubmitIsSuccess) {
      const sucessMessage = `${
        ipSupplyOrderQueryData?.order_number
      } was approved.Submitted by ${user} ${getPreferredDateTimeInLocal(ipSupplyOrderQueryData?.updated_on)}`;
      dispatchApp(setMessage({ msgDetails: sucessMessage, severity: 'success' }));
      setOpenSponsorSubmitModal(false);
      accRef?.current?.scrollTo(0, 0);
      getIpSupplyOrderQueryData();
    }
  }, [approveSubmitIsSuccess]);

  const handleConfirmExitSave = () => {
    filterValues({});
    setIsSupplyChanged(false);
    setOpenConfirmExit(false);
    dispatch(setOpenResupplyOrderPage(false));
    dispatch(setNewResupplyOrder(false));
    dispatch(setSelectedResupply({}));
    setConfirmExitValue(dispatch, false);
  };

  /* Resupply order user story */
  const { userPreferedDateFormat } = usePreferedDateFormat();
  const openResupplyOrder = useAppSelector(state => state.drugSupplySlice.openResupplyOrderPage);
  const [pageSize, setPageSize] = useState(10);
  const [rowsCount, setRowsCount] = useState(0);
  const [pageNumber, setPageNumber] = useState(0);
  const [filterObject, setFilterObject] = useState<any>({});
  const [rowArr, setRowArr] = useState<any[]>([]);
  const selectResupplyData: any = useAppSelector(state => state.drugSupplySlice.selectedResupply);

  const handleOpenResupplyOrder = (data: any) => {
    dispatch(setOpenResupplyOrderPage(true));
    dispatch(setNewResupplyOrder(true));
    dispatch(setSelectedResupply(data));
  };

  const { data: codeListData } = useGetSysAdminNewCodelistQuery('IPSPOST');

  const Tablecolumns = [
    {
      field: 'resupply_name',
      headerName: 'Log',
      minWidth: 100,
      width: 200,
      renderCell: (params: any) => (
        <Link underline="always" onClick={field => handleOpenResupplyOrder(params.row)}>
          {params.value?.toString()}
        </Link>
      )
    },
    {
      field: 'created_by',
      headerName: 'Created By',
      minWidth: 100,
      width: 150
    },
    {
      field: 'updated_by',
      headerName: 'Modified By',
      minWidth: 100,
      width: 200
    },
    {
      field: 'status',
      headerName: 'Status',
      minWidth: 100,
      width: 200,
      type: 'singleSelect',
      valueOptions: codeListData?.map((item: any) => item?.code_list_value)
    }
  ];

  const definedCustomDatGridExport = (exportFields: any = {}) => {
    return (
      <GridToolbarExport
        csvOptions={{
          fileName: `Investigational Product Resupply Order ${moment(new Date()).format(
            `${(userPreferedDateFormat.includes('/')
              ? userPreferedDateFormat.replaceAll('/', '_')
              : userPreferedDateFormat.replaceAll('-', '_')
            ).toUpperCase()} hh_mm A`
          )}`
        }}
      />
    );
  };

  const getAllResupplyFunc = (from: number, size: number) => {
    archLevel == 'site'
      ? getAllIpResupply({
          study_id: studyId,
          site_id: selectedSite,
          country: selectedCountry,
          application: process.env.REACT_APP_NAME_TEMP,
          application_section: currentApp,
          data: filterObject,
          from,
          size
        })
      : getAllIpResupplySponsor({
          study_id: studyId,
          site_id: selectedSite,
          country: selectedCountry,
          application: process.env.REACT_APP_NAME_TEMP,
          application_section: currentApp,
          data: filterObject,
          from,
          size
        });
  };

  const dataTableProps = {
    filterMode: 'server'
  };

  const filterValues = (data: any) => {
    setFilterObject(data);
  };

  const addResupplyOrder = () => {
    dispatch(setOpenResupplyOrderPage(true));
    dispatch(setNewResupplyOrder(true));
    setIsSubmitted(false);
    setIsSignsCompleted(false);
  };
  const handelBack = () => {
    filterValues({});
    if (isIPSupplyChanged) {
      setOpenConfirmExit(true);
    } else {
      dispatch(setOpenResupplyOrderPage(false));
      dispatch(setNewResupplyOrder(false));
      dispatch(setSelectedResupply({}));
    }
  };

  useEffect(() => {
    if (ipResupplyIsError || ipResupplySponsorIsError) {
      const err: any = ipResupplyError ?? ipResupplySponsorError;
      handleError(err);
      setRowArr([]);
      setRowsCount(0);
    }
  }, [ipResupplyIsError, ipResupplySponsorIsError]);

  useEffect(() => {
    if (pageSize === 10 || pageSize === 20 || pageSize === 30) {
      if (pageNumber * pageSize > rowsCount - 1) {
        setPageNumber(0);
        getAllResupplyFunc(0, pageSize);
      } else {
        getAllResupplyFunc(pageNumber * pageSize, pageSize);
      }
    }
  }, [selectedSite, pageNumber, pageSize, filterObject, openResupplyOrder]);

  useEffect(() => {
    if (ipResupplyData && ipResupplyIsSuccess) {
      setRowArr(ipResupplyData?.selected_data);
      setRowsCount(ipResupplyData?.record_count);
    }
    if (ipResupplySponsorData && ipResupplySponsorIsSuccess) {
      setRowArr(ipResupplySponsorData?.selected_data);
      setRowsCount(ipResupplySponsorData?.record_count);
    }
  }, [ipResupplyData, ipResupplyIsSuccess, ipResupplySponsorData, ipResupplySponsorIsSuccess]);

  return (
    <>
      {checkPermission('view_ip_management') ? (
        <div className="pi-accordion site-documents lastAccordionSetting4">
          {isLoading && <ProgressBar />}
          {currentApp === 'STARTUP' ? (
            <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1bh-content" id="panel1bh-header">
                <Typography sx={{ width: '33%', flexShrink: 0 }}>
                  Investigational Product Release (to be completed by Sponsor)
                </Typography>
              </AccordionSummary>
              <AccordionDetails className="ip-release-tab">
                <Ipreleasepage
                  ipReleaseData={ipReleaseData}
                  setIPReleaseData={setIPReleaseData}
                  updatedIPReleaseDocs={updatedIPReleaseDocs}
                  setUpdatedIPReleaseDocs={setUpdatedIPReleaseDocs}
                  createIPRelease={createIPRelease}
                  updateIPRelease={updateIPRelease}
                  checkboxVal={checkboxVal}
                  setCheckboxVal={setCheckboxVal}
                  checkboxInputRef={checkboxInputRef}
                  isIPReleaseSaved={isIPReleaseSaved}
                  setIsIPReleaseSaved={setIsIPReleaseSaved}
                  isSubmitted={isSubmitted}
                  IPRTSData={iprtsData}
                  IPCodeList={ipCodeList}
                  setIsSubmitted={setIsSubmitted}
                  isIpReleaseCertified={isIpReleaseCertified}
                  isSignsCompletedLegacy={isSignsCompletedLegacy}
                />
              </AccordionDetails>
            </Accordion>
          ) : null}
          {currentApp === 'STARTUP' ? (
            <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1bh-content" id="panel1bh-header">
                <Typography sx={{ width: '33%', flexShrink: 0 }}>Investigational Product Supply Order</Typography>
              </AccordionSummary>
              <AccordionDetails className="ip-release-tab" ref={accRef}>
                {(archLevel === 'site' && ipReleaseData?.find((ele: any) => ele.ip_management_certify_info)) ||
                (archLevel === 'sponsor' && ipSupplyOrderQueryData?.order_number) ||
                isSubmitted ? (
                  <IpSupplyOrderpage
                    isSubmitted={isSubmitted}
                    setIsIPSupplySaved={setIsIPSupplySaved}
                    isSignsCompleted={isSignsCompleted}
                    setIsSignsCompleted={setIsSignsCompleted}
                    isIpReleaseCertified={isIpReleaseCertified}
                    setIsSignsCompletedLegacy={setIsSignsCompletedLegacy}
                    isIPSupplySaved={isIPSupplySaved}
                    isIPSupplyChanged={isIPSupplyChanged}
                    setIsSupplyChanged={setIsSupplyChanged}
                  />
                ) : archLevel === 'sponsor' && !ipSupplyOrderQueryData?.order_number ? (
                  <Alert severity="warning">
                    This section will get enabled only when the Investigational Product Supply Order request is raised
                    by site
                  </Alert>
                ) : (
                  <Alert severity="warning">
                    This section will get enabled only when the Investigational Product Release section is certified.
                  </Alert>
                )}
              </AccordionDetails>
            </Accordion>
          ) : (
            <>
              {openResupplyOrder ? (
                <>
                  <Box className="mainBackBtnWrap" sx={{ ml: 0.5 }}>
                    <Button onClick={handelBack} startIcon={<ArrowBackIcon fontSize="small" />}>
                      BACK
                    </Button>
                  </Box>
                  <Typography variant="h6" component="h6" sx={{ mt: 0, mb: 1.5, ml: 1 }}>
                    Investigational Product Resupply Order {selectResupplyData?.resupply_seq_no}
                  </Typography>
                  <Box
                    className="ip-release-tab"
                    sx={{
                      marginBottom: '16px',
                      maxHeight: 'fit-content',
                      '& .fixed-buttons-block': { position: 'relative !important' }
                    }}
                  >
                    <IpSupplyOrderpage
                      isSubmitted={isSubmitted}
                      setIsIPSupplySaved={setIsIPSupplySaved}
                      isSignsCompleted={isSignsCompleted}
                      setIsSignsCompleted={setIsSignsCompleted}
                      isIpReleaseCertified={isIpReleaseCertified}
                      setIsSignsCompletedLegacy={setIsSignsCompletedLegacy}
                      isIPSupplyChanged={isIPSupplyChanged}
                      setIsSupplyChanged={setIsSupplyChanged}
                    />
                  </Box>
                </>
              ) : (
                <>
                  <Grid item md={12} sx={{ position: 'relative' }}>
                    <Box sx={{ position: 'absolute', bottom: '0', right: '0' }}>
                      {archLevel === 'site' && (
                        <Button
                          style={{ float: 'right', position: 'relative', zIndex: 1200 }}
                          variant="contained"
                          onClick={addResupplyOrder}
                          disabled={
                            !checkPermission('add_ip_resupply_order_request') || !ipSupplyData?.is_sponsor_approved
                          }
                        >
                          ADD REQUEST
                        </Button>
                      )}
                    </Box>
                  </Grid>
                  <br />
                  <DataTable
                    height="74vh"
                    hasDefinedColumns
                    showDateAndTime
                    pagination
                    hasDefinedDataGridToolbarExport
                    columns={Tablecolumns}
                    rows={rowArr}
                    loading={ipResupplyIsLoading || ipResupplySponsorIsLoading}
                    paging
                    rowsCount={rowsCount}
                    pageNumber={pageNumber}
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                    setPageNumber={setPageNumber}
                    paginationMode="server"
                    disableSelectionOnClick={false}
                    datePreference={userPreferedDateFormat}
                    definedGridToolbarExport={definedCustomDatGridExport}
                    filterValues={(data: any) => filterValues(data)}
                    dataTableProps={dataTableProps}
                  />
                </>
              )}
            </>
          )}

          <Grid container>
            <PopupComponent
              open={openSubmitConfirmDialog}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              className="confirm-modal"
            >
              <DialogTitle id="alert-dialog-title">{'Confirm Submit'}</DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  <span>
                    Are you sure you want to submit? <br />
                    Additional changes cannot be made once submitted
                  </span>
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleConfirmClose}>CANCEL</Button>
                <Button onClick={handleConfirmSubmit} autoFocus>
                  OK
                </Button>
              </DialogActions>
            </PopupComponent>
          </Grid>
          {currentApp == 'STARTUP' ? (
            <Grid container spacing={2} className="bottom-navigation">
              <Grid item md={12} display="flex" justifyContent="flex-end">
                <Stack spacing={2} direction="row">
                  <>
                    {!isSubmitted &&
                      checkPermission('update_ip_supply_order') &&
                      (archLevel == 'sponsor'
                        ? !ipSupplyOrderQueryData?.is_sponsor_approved && (
                            <Button
                              variant="contained"
                              disabled={
                                !checkPermission('approve_ip_supplyorder_sponsor') ||
                                !ipSupplyOrderQueryData?.ip_sponsor_reviewed_by ||
                                !checkPermission('update_ip_release')
                              }
                              onClick={handleSponsorSubmit}
                            >
                              SUBMIT
                            </Button>
                          )
                        : !ipSupplyOrderQueryData?.order_number && (
                            <Button
                              variant="contained"
                              disabled={
                                !ipSupplyOrderQueryData?.ip_site_signed_by || !checkPermission('update_ip_release')
                              }
                              onClick={handleSiteSubmit}
                            >
                              SUBMIT
                            </Button>
                          ))}
                  </>
                  {currentTabinfo[0]?.NextButton && (
                    <Button variant="contained" onClick={handleNextbtn}>
                      NEXT
                    </Button>
                  )}
                  {/* <Button onClick={handleSubmitDummy}>Submit Dummy</Button> */}
                </Stack>
              </Grid>
            </Grid>
          ) : null}
        </div>
      ) : (
        <></>
      )}
      {openSubmitModal && (
        <IpMangementSubmitModal
          openSubmitModal={openSubmitModal}
          setOpenSubmitModal={setOpenSubmitModal}
          user={user}
          ipSupplyOrderQueryData={ipSupplyOrderQueryData}
          setSiteSubmitSuccess={setSiteSubmitSuccess}
        />
      )}
      {openSponsorSubmitModal && (
        <AppModal
          open={openSponsorSubmitModal}
          title={'Confirm'}
          saveButton={'OK'}
          closeButton={'CANCEL'}
          handleSubmit={() => handleApproveSubmit()}
          handleClose={() => setOpenSponsorSubmitModal(false)}
          maxWidth="600px"
          outSideClickClose
        >
          <Typography variant="body1" mb="24px">
            Are you sure you want to submit? Additional changes cannot be made once submitted
          </Typography>
        </AppModal>
      )}
      <PopupComponent
        open={openConfirmExit}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="confirm-modal"
        child
      >
        <DialogTitle id="alert-dialog-title">{'Confirm Exit'}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">{unSavedWarning}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpenConfirmExit(false);
            }}
            className="grey-btn"
          >
            Close
          </Button>
          <Button onClick={handleConfirmExitSave}>Ok</Button>
        </DialogActions>
      </PopupComponent>
    </>
  );
};

export default IpManagementPage;
